import { Divider, Drawer } from '@material-ui/core';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useState } from 'react';
import CloseFiltersButton from 'shared/components/Table/CloseFiltersButton';
import FiltersButton from 'shared/components/Table/FiltersButton';
import TableToolbar from 'shared/components/Table/TableToolbar';
import RefreshList from 'shared/components/Table/Refresh';
import ColumnSelector from 'shared/components/Table/actions-buttons/ColumnSelector';
import TrashAllFilters from 'shared/components/filters/TrashAllFilters';
import ContingencyModal from 'app/viaje/viajeTraslado/coordinar/components/ContingencyModal';
import { Contingency } from 'app/viaje/viajeTraslado/coordinar/services/contingencyService';
import CreateContingencyButton from '../components/CreateContingencyButton';
import ContingenciesChipsBar from '../components/ContingenciesChipsBar';
import ContingenciesFilters from '../components/ContingenciesFilters';
import ContingenciesTable from '../components/ContingenciesTable';
import {
  contingencyColumnLabels,
  DEFAULT_CONTINGENCY_FILTERS,
  useContingencies
} from '../hooks/useContingencies';

const ContingenciesControlPage = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [editing, setEditing] = useState<Contingency | null>(null);

  const {
    contingencies,
    page,
    rowsPerPage,
    sort,
    filters,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange,
    onFiltersChange,
    resetFilters,
    columnVisibility,
    setColumnVisibility,
    deleteMutation
  } = useContingencies();

  return (
    <div>
      <div
        className="sticky top-0 right-0 left-0 flex flex-col w-full"
        style={{ zIndex: 101, background: 'transparent' }}
      >
        <div
          className="flex flex-col w-full"
          style={{ background: '#EAEDF5' }}
        >
          <PageHeader
            area="Inventarios"
            subArea="Gestión Contingencias"
            title="Control de Contingencias"
            toolbar={
              <div className="flex gap-4 items-center">
                <CreateContingencyButton onSuccess={contingencies.reload} />
                <RefreshList
                  onRefreshTable={async () => {
                    await contingencies.reload();
                  }}
                  isRefreshing={contingencies.isLoading}
                  color="#005DFA"
                  hoverColor="#005DFA"
                  transitionDuration="0.3s"
                  size={25}
                />
              </div>
            }
          />
        </div>
        <div
          className="flex w-full px-8 pt-2"
          style={{ marginBottom: '-24px', background: '#EAEDF5' }}
        >
          <TableToolbar
            chips={
              <ContingenciesChipsBar
                filters={filters}
                onFiltersChange={onFiltersChange}
              />
            }
            actions={
              <>
                <ColumnSelector
                  columns={columnVisibility}
                  onChange={setColumnVisibility}
                  columnLabels={contingencyColumnLabels}
                />
                <FiltersButton
                  onClick={() => setShowFilters(true)}
                  isActive={showFilters}
                />
              </>
            }
          />
        </div>
      </div>

      <Drawer
        variant="persistent"
        anchor="right"
        open={showFilters}
        className="max-w-md"
        transitionDuration={300}
      >
        <div className="flex flex-col h-full">
          <div
            className="flex justify-between items-center px-2"
            style={{ backgroundColor: '#00163B' }}
          >
            <CloseFiltersButton
              onCloseFilters={() => setShowFilters(false)}
              inOpen={showFilters}
            />
            <TrashAllFilters onClick={resetFilters} />
          </div>
          <Divider />
          <ContingenciesFilters
            initialValues={filters}
            onSubmit={(next) => {
              onFiltersChange(next);
              setShowFilters(false);
            }}
          />
        </div>
      </Drawer>

      <PageContainer lessMargin>
        <ContingenciesTable
          contingencies={contingencies.data}
          total={contingencies.total}
          page={page}
          rowsPerPage={rowsPerPage}
          sort={sort}
          columnVisibility={columnVisibility}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onSortChange={onSortChange}
          onEdit={(row) => setEditing(row)}
          onDelete={(id) => deleteMutation.mutate(id)}
          isDeleting={deleteMutation.isLoading}
        />
      </PageContainer>

      <ContingencyModal
        isOpen={!!editing}
        onClose={() => setEditing(null)}
        contingency={editing}
        onSuccess={contingencies.reload}
      />
    </div>
  );
};

export { DEFAULT_CONTINGENCY_FILTERS };
export default ContingenciesControlPage;
